import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

import mediaQueries from '@/theme/mediaQueries';
import { borderRadius } from '@/theme/selectors';

export const Container = styled.div`
    width: 100%;
    padding: 24px;

    ${mediaQueries.laptop} {
        padding: 48px 0 48px 56px;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 12px;
    align-items: center;
    margin-bottom: 24px;
`;

export const Link = styled(RouterLink)`
    display: none;

    ${mediaQueries.laptop} {
        border-radius: 100%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${({ theme }) => theme['surface-default']};
    }
`;

export const Content = styled.div`
    flex: 1;
    background-color: ${({ theme }) => theme['surface-default']};
    padding: 24px 16px;
`;

export const RecipeContainer = styled.main`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    max-width: 600px;

    ${mediaQueries.laptop} {
        border-radius: ${borderRadius('medium')};
    }
`;
